import React, { useState } from "react";
import HomeImage from "../assets/images/home.png";
import NepalFlag from "../assets/gifs/Flag_of_Nepal.gif";

function Home() {
    const [showCVModal, setShowCVModal] = useState(false);

    const openCVModal = (e) => {
        e.preventDefault();
        setShowCVModal(true);
        document.body.style.overflow = "hidden";
    };

    const closeCVModal = () => {
        setShowCVModal(false);
        document.body.style.overflow = "auto";
    };

    return (
        <section className="home" id="home">
            <div className="home-content">
                <div className="flag-container">
                    <div className="flag-top"></div>
                    <img src={NepalFlag} alt="Flag of Nepal" className="gif-image" />
                    <div className="flag-bottom"></div>
                </div>
                <h3>Hello World! I am,</h3>
                <h1>Rastra D. Karki</h1>
                <p>
                    AI Engineer and Full Stack Developer with 5+ years of experience. MSc
                    in AI from Queen Mary University of London. Specializing in Machine
                    Learning, Computer Vision, and scalable web applications. Passionate
                    about building intelligent solutions that make a real impact.
                </p>

                <div className="social-media">
                    <a
                        href="https://github.com/Rastra17"
                        target="_blank"
                        rel="noopener noreferrer"
                        aria-label="GitHub Profile"
                        title="GitHub"
                    >
                        <i className="bx bxl-github"></i>
                    </a>
                    <a
                        href="https://www.linkedin.com/in/rastrakarki/"
                        target="_blank"
                        rel="noopener noreferrer"
                        aria-label="LinkedIn Profile"
                        title="LinkedIn"
                    >
                        <i className="bx bxl-linkedin-square"></i>
                    </a>
                    <a
                        href="https://www.facebook.com/rastrakarki"
                        target="_blank"
                        rel="noopener noreferrer"
                        aria-label="Facebook Page"
                        title="Facebook"
                    >
                        <i className="bx bxl-facebook-circle"></i>
                    </a>
                    <a
                        href="mailto:rastradhoj@gmail.com"
                        aria-label="Email Me"
                        title="Email"
                    >
                        <i className="bx bxl-gmail"></i>
                    </a>
                </div>

                <div className="btn-container">
                    <a
                        href="/assets/pdf/Resume.pdf"
                        download="Rastra_D_Karki_Resume.pdf"
                        className="btn"
                    >
                        <i className="bx bx-download"></i> Download CV
                    </a>
                    <button className="btn btn-outline" onClick={openCVModal}>
                        <i className="bx bx-show"></i> View CV
                    </button>
                </div>
            </div>

            <div className="profession-container">
                <div className="profession-box">
                    <div className="profession" style={{ "--i": 0 }}>
                        <i className="bx bx-brain"></i>
                        <h3>AI Engineer</h3>
                    </div>
                    <div className="profession" style={{ "--i": 1 }}>
                        <i className="bx bx-code-curly"></i>
                        <h3>Web Developer</h3>
                    </div>
                    <div className="profession" style={{ "--i": 2 }}>
                        <i className="bx bx-code-alt"></i>
                        <h3>Software Eng.</h3>
                    </div>
                    <div className="profession" style={{ "--i": 3 }}>
                        <i className="bx bxs-data"></i>
                        <h3>Data Scientist</h3>
                    </div>
                    <div className="circle"></div>
                </div>
                <div className="overlay"></div>
            </div>

            <div className="home-img">
                <img src={HomeImage} alt="Rastra D. Karki" />
            </div>

            {/* CV Modal */}
            <div
                className={`cv-modal ${showCVModal ? "active" : ""}`}
                onClick={closeCVModal}
            >
                <div className="cv-modal-content" onClick={(e) => e.stopPropagation()}>
                    <div className="cv-modal-header">
                        <h3>Resume - Rastra D. Karki</h3>
                        <button className="cv-modal-close" onClick={closeCVModal}>
                            <i className="bx bx-x"></i>
                        </button>
                    </div>
                    <div className="cv-modal-body">
                        <iframe
                            src="/assets/pdf/Resume.pdf"
                            title="CV Preview"
                            loading="lazy"
                        />
                    </div>
                </div>
            </div>
        </section>
    );
}

export default Home;
